class ProductStickyBar {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._elemsToSkip = document.querySelectorAll('[data-product-sticky-bar-skip]')
        this._sticked = false
    }

    onInit () {
        this._offset = this.getOffset(this._elemsToSkip)
        this.createEvent()
    }

    createEvent () {
        let evt = new CustomEvent('sticky-header')
        document.addEventListener('scroll', e => this.checkTop(evt))
        window.addEventListener('load', e => this.checkTop(evt))
    }

    checkTop (evt) {
        let docTop = document.documentElement.scrollTop
        if (docTop >= this._offset && !this._stickied) {
            this._stickied = true
            this._elem.classList.add('shown')
        } else if (docTop <= this._offset && this._stickied) {
            this._stickied = false
            this._elem.classList.remove('shown')
            evt.hit = this._stickied
            this._elem.dispatchEvent(evt)
        }
    }

    getOffset (elems) {
        let retOffset = 0
        for (let elem of elems) {
            retOffset += elem.offsetHeight
        }
        return retOffset
    }
}

export default ProductStickyBar



// WEBPACK FOOTER //
// ./src/scripts/components/ProductStickyBar.js